import { EditProcessStepRecordingRequestSchema, EditProcessStepRecordingResponseSchema } from './edit-process-step-recording.schema';
/**
 * Edit Process Step Recording Endpoint Contract
 * Updates a process step recording entity
 */ export const editProcessStepRecordingContract = {
    method: 'PATCH',
    path: '/api/v2/process-step-recording/:id',
    description: 'Edit process step recording entity fields',
    requestSchema: EditProcessStepRecordingRequestSchema,
    responseSchema: EditProcessStepRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            400: 'Invalid request body',
            403: 'Forbidden - user does not have permission to edit this recording',
            404: 'Process step recording not found'
        }
    }
};

//# sourceMappingURL=edit-process-step-recording.contract.js.map